<template>
  <div class="demo Bgc-white">
    <div class="container containerElements">
      <div class="row">
        <Video></Video>
        <promos></promos>
        <HotelCards></HotelCards> 
      </div>
    </div>
  </div>
          
</template>

<script>
 import { VueAgile } from '../../customComponents/vue-agile';
  import Video from './Video.vue';
 import Promos from './Promos.vue';
 import HotelCards from './HotelCards.vue';

 
export default {
  components: {
    Video,
    Promos,
    HotelCards,
    agile: VueAgile,
  },
  name: 'Elementos',
  data: function(){
    return {
      isModalVisible: false,
      card: null,
      currentId: null,
      asNavFor1: [],
      comodidades: false,
      ubicacion: false,
      horarios: false,
      asNavFor2: [],
      sliderRow1: true,
      sliderRow2: true,
      sliderRow3: true,
      sliderRow4: true,
      sliderRow5: true,
      sliderRow6: true,
      currentId: null,
			options1: {
				dots: false,
				fade: true,
				navButtons: false
			},
			options2: {
				autoplay: true,
				centerMode: true,
				dots: false,
				navButtons: false,
				slidesToShow: 3,
				responsive: [
          {
            breakpoint: 600,
            settings: {
                slidesToShow: 5
            }
          },
          {
            breakpoint: 1000,
            settings: {
                navButtons: true
            }
          }
        ]
      },
    }
  },
  methods: {
    showModal() {
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  // Temporal en lo que tenemos logo
  @import '../../assets/scss/config.scss';
  
  .demo {
    padding-top: 32px;
    padding-bottom: 32px;
    margin-top: 57px;
    // margin-left: 20%;
    display: inline-block;
    vertical-align: top;
    float: right;
    width: 80%;
    min-height: 85vh;
    border-left: 2px solid $colorBase5; 

    .containerElements {
      padding: 0 0%;
    }
  }
  @media only screen and (max-width: 1440px) {
    .demo {
      // margin-left: 25%;
      width: 75%;
      .containerElements {
        padding: 0 22px;
      }
    }
  }
  @media only screen and (max-width: 1100px) {
    .demo {
      // margin-left: 25%;
      width: 75%;
      .containerElements {
        padding: 0 15px;
      }
    }
  }
  @media only screen and (max-width: 992px) {
    .demo {
      margin-left: 0;
      float: none;
      width: 100%;
      margin-top: 24px;
      border-left: none;
      padding-top: 24px;
      border-top: 2px solid $colorBase5; 
    }
  }
  </style>